import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { customFetchBase } from '../../utils/API/fetchBaseQuery';
import { encryptQueryString, transformRequest } from "../../utils/API/requestMiddleware";
import { transformSucessResponse, transformErrorResponse } from "../../utils/API/responseMiddleware";

const questionaryAPI = createApi({
    reducerPath: 'questionaryAPI',
    baseQuery: customFetchBase,
    endpoints: (builder) => ({

        addQuestionary: builder.mutation({
            query: (data) => ({
                url: '/Questionary/AddQuestionary',
                method: 'POST',
                body: transformRequest(data)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        updateQuestionary: builder.mutation({
            query: (data) => ({
                url: '/Questionary/UpdateQuestionary',
                method: 'POST',
                body: transformRequest(data)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getQuestionaryById: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/Questionary/GetQuestionaryById/?id=${Number(id)}`),
                method: 'GET'
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getAllQuestionDataType: builder.mutation({
            query: () => ({
                url: encryptQueryString('/Question/GetAllQuestionDataType'),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        deleteQuestionary: builder.mutation({
            query: (id) => ({
                url: `/Question/DeleteQuestionary/?id=${id}`,
                method: 'DELETE',
                body: transformRequest(id)
            }),
        })

    })
})

export const { useAddQuestionaryMutation, useLazyGetQuestionaryByIdQuery,
    useUpdateQuestionaryMutation, useGetAllQuestionDataTypeMutation, useDeleteQuestionaryMutation } = questionaryAPI;

export default questionaryAPI;